import { Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_uLearn/layout/core';
import { lazy } from 'react';
import EditSchool from './edit-school';
const AllSchools = lazy(() => import('./all-schools'));
const AddSchool = lazy(() => import('./add-school'));
const profileBreadCrumbs: Array<PageLink> = [
  {
    title: 'Profile',
    path: 'schools',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const index = () => (
  <Routes>
    <Route
      element={
        <>
          <Outlet />
        </>
      }
    >
      <Route
        // path=""
        index
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Schools</PageTitle>
            <AllSchools />
          </>
        }
      />
      <Route
        path="/add-school"
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Add School</PageTitle>
            <AddSchool />
          </>
        }
      />
      <Route
        path="/edit-school"
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Edit School</PageTitle>
            <EditSchool />
          </>
        }
      />
    </Route>
  </Routes>
);
export default index;
